import axios from "axios";
import urls from "./urls";
import authAxios from './../apis/axios';

export const userLogout = async (data) => {
    try {
        const response = await authAxios({
            method: 'POST',
            url: urls.logout_url,
            data: {}
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const deleteRecord = async (url) => {
    try {
        const response = await authAxios({
            method: 'DELETE',
            url: urls.delete_record + url,
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const getAllBrands = async (data) => {
    try {
        const response = await authAxios({
            method: 'GET',
            url: urls.get_all_brands,
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const createBrand = async (data) => {
    try {
        const response = await authAxios({
            method: 'POST',
            url: urls.create_brand,
            headers: {
                'Content-Type': "application/multi-part"
            },
            data: data
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const updateBrand = async (data) => {
    try {
        const response = await authAxios({
            method: 'POST',
            url: urls.update_brand,
            headers: {
                'Content-Type': "application/multi-part"
            },
            data: data
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const getAllCategories = async (data) => {
    try {
        const response = await authAxios({
            method: 'GET',
            url: urls.get_all_categories,
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const createCategory = async (data) => {
    try {
        const response = await authAxios({
            method: 'POST',
            url: urls.create_category,
            headers: {
                'Content-Type': "application/multi-part"
            },
            data: data
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const editCategory = async (data) => {
    try {
        const response = await authAxios({
            method: 'POST',
            url: urls.edit_category,
            headers: {
                'Content-Type': "application/multi-part"
            },
            data: data
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const getAllUsers = async (data) => {
    try {
        const response = await authAxios({
            method: 'GET',
            url: urls.get_all_users,
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const createUser = async (data) => {
    try {
        const response = await authAxios({
            method: 'POST',
            url: urls.create_user,
            headers: {
                'Content-Type': "application/multi-part"
            },
            data: data
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const editUser = async (data) => {
    try {
        const response = await authAxios({
            method: 'POST',
            url: urls.edit_user,
            headers: {
                'Content-Type': "application/multi-part"
            },
            data: data
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const getAllCurrencies = async () => {
    try {
        const response = authAxios({
            method: "GET",
            url: urls.get_all_currencies
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const storeCurrency = async (data) => {
    try {
        const response = authAxios({
            method: "POST",
            data: data,
            url: urls.create_currency,
            headers: {
                'Content-Type': "application/multi-part"
            },
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const updateCurrency = async (data) => {
    try {
        const response = authAxios({
            method: "POST",
            data: data,
            url: urls.update_currency,
            headers: {
                'Content-Type': "application/multi-part"
            },
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const saveShippingZone = async (data) => {
    try {
        const response = authAxios({
            method: "POST",
            data: data,
            url: urls.save_shipping_zone,
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const getAllShippingZones = async () => {
    try {
        const response = authAxios({
            method: "GET",
            url: urls.get_all_shipping_zones,
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const updateShippingZone = async (data) => {
    try {
        const response = authAxios({
            method: "POST",
            data: data,
            url: urls.update_shipping_zone,
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const getAllProductAttributes = async () => {
    try {
        const response = authAxios({
            method: "GET",
            url: urls.get_all_product_attributes,
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const saveProductAttribute = async (data) => {
    try {
        const response = authAxios({
            method: "POST",
            data: data,
            url: urls.save_product_attribute,
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const updateProductAttribute = async (data) => {
    try {
        const response = authAxios({
            method: "POST",
            data: data,
            url: urls.update_product_attribute,
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const getAllAttributeValues = async () => {
    try {
        const response = authAxios({
            method: "GET",
            url: urls.get_product_attribute_values,
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const saveProductAttributeValue = async (data) => {
    try {
        const response = authAxios({
            method: "POST",
            url: urls.save_product_attribute_value,
            data: data
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const updateProductAttributeValue = async (data) => {
    try {
        const response = authAxios({
            method: "POST",
            url: urls.update_product_attribute_value,
            data: data
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const getActiveAttributes = async () => {
    try {
        const response = authAxios({
            method: "GET",
            url: urls.get_active_product_attributes,
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const getAllUnits = async () => {
    try {
        const response = authAxios({
            method: "GET",
            url: urls.get_all_units,
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const saveUnit = async (data) => {
    try {
        const response = authAxios({
            method: "POST",
            url: urls.save_unit,
            data: data,
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const updateUnit = async (data) => {
    try {
        const response = authAxios({
            method: "POST",
            url: urls.update_unit,
            data: data,
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const getProductFormData = async () => {
    try {
        const response = authAxios({
            method: "GET",
            url: urls.get_product_form_data,
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const saveProduct = async (data) => {
    try {
        const response = authAxios({
            method: "POST",
            url: urls.save_product,
            data: data,
            headers: {
                'Content-Type': "application/multi-part"
            },
        });
        return response;
    } catch (error) {
        return error;
    }
}

export const updateProduct = async (data) => {
    try {
        const response = authAxios({
            method: "POST",
            url: urls.update_product,
            data: data,
            headers: {
                'Content-Type': "application/multi-part"
            },
        });
        return response;
    } catch (error) {
        return error;
    }

}



export const searchProductsStrictly = async (params) => {
    try {
        const response = authAxios({
            method: "GET",
            url: urls.search_products_strictly,
            params: params,
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const getAllProducts = async () => {
    try {
        const response = authAxios({
            method: "GET",
            url: urls.get_all_products,
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const saveCollection = async (data) => {
    try {
        const response = authAxios({
            method: "POST",
            data: data,
            url: urls.save_collection,
            headers: {
                'Content-Type': "application/multi-part"
            },
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const updateCollection = async (data) => {
    try {
        const response = authAxios({
            method: "POST",
            data: data,
            url: urls.update_collection,
            headers: {
                'Content-Type': "application/multi-part"
            },
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const getAllCollections = async () => {
    try {
        const response = authAxios({
            method: "GET",
            url: urls.get_all_collections,

        });
        return response;
    } catch (error) {
        return error;
    }
}
export const getActiiveCollections = async () => {
    try {
        const response = axios({
            method: "GET",
            url: urls.get_active_collections,

        });
        return response;
    } catch (error) {
        return error;
    }
}
export const getAllBanners = async () => {
    try {
        const response = authAxios({
            method: "GET",
            url: urls.get_all_banners,

        });
        return response;
    } catch (error) {
        return error;
    }
}
export const saveBanner = async (data) => {
    try {
        const response = authAxios({
            method: "POST",
            data: data,
            url: urls.save_banner,
            headers: {
                'Content-Type': "application/multi-part"
            },

        });
        return response;
    } catch (error) {
        return error;
    }
}
export const updateBanner = async (data) => {
    try {
        const response = authAxios({
            method: "POST",
            data: data,
            url: urls.update_banner,
            headers: {
                'Content-Type': "application/multi-part"
            },

        });
        return response;
    } catch (error) {
        return error;
    }
}
export const updateProductSettings = async (data) => {
    try {
        const response = authAxios({
            method: "POST",
            data: data,
            url: urls.update_product_settings,
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const getProductsByCollection = async (params) => {
    try {
        const response = authAxios({
            method: "GET",
            params: params,
            url: urls.get_products_by_collection,
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const updateProductsInCollection = async (data) => {
    try {
        const response = authAxios({
            method: "POST",
            data: data,
            url: urls.update_products_in_collection,
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const getAllProductFields = async () => {
    try {
        const response = authAxios({
            method: "GET",
            url: urls.get_all_product_fields,
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const saveProductField = async (data) => {
    try {
        const response = authAxios({
            method: "POST",
            url: urls.save_product_field,
            data: data
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const updateProductField = async (data) => {
    try {
        const response = authAxios({
            method: "POST",
            url: urls.update_product_field,
            data: data
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const upadteShippingSettings = async (data) => {
    try {
        const response = authAxios({
            method: "POST",
            url: urls.upadte_shipping_settings,
            data: data
        });
        return response;
    } catch (error) {
        return error;
    }
}

export const getAllActiveSales = async (params) => {
    try {
        const response = authAxios({
            method: "GET",
            url: urls.get_all_active_sales,
            params: params
        });
        return response;
    } catch (error) {
        return error;
    }
}

export const getProductVariationTypes = async (data) => {
    try {
        const response = authAxios({
            method: "POST",
            url: urls.get_product_variation_types,
            data: data
        });
        return response;
    } catch (error) {
        return error;
    }
}

export const addProductVariation = async (data) => {
    try {
        const response = authAxios({
            method: "POST",
            url: urls.add_product_variation,
            data: data
        });
        return response;
    } catch (error) {
        return error;
    }
}

export const updateProductVariation = async (data) => {
    try {
        const response = authAxios({
            method: "POST",
            url: urls.update_product_variation,
            data: data
        });
        return response;
    } catch (error) {
        return error;
    }
}

export const getAllProductVariations = async (params) => {
    try {
        const response = authAxios({
            method: "GET",
            url: urls.get_all_product_variations,
            params: params
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const updateProductImages = async (data) => {
    try {
        const response = authAxios({
            method: "POST",
            url: urls.update_product_images,
            data: data,
            headers: {
                'Content-Type': "application/multi-part"
            },

        });
        return response;
    } catch (error) {
        return error;
    }
}

export const selfUpdateUser = async (data) => {
    try {
        const response = authAxios({
            method: "POST",
            url: urls.self_update_user,
            data: data,
            headers: {
                'Content-Type': "application/multi-part"
            },
        });
        return response;
    } catch (error) {
        return error;
    }
}


export const updateStoreData = async (data) => {
    try {
        const response = authAxios({
            method: "POST",
            url: urls.update_store_data,
            data: data,
            headers: {
                'Content-Type': "application/multi-part"
            },
        });
        return response;
    } catch (error) {
        return error;
    }
}

export const getSaleDetails = async (params) => {
    try {
        const response = authAxios({
            method: "GET",
            url: urls.get_sale_details,
            params: params,
        });
        return response;
    } catch (error) {
        return error;
    }
}







